import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchDashboardData } from "../../../features/dashboard/services/dashboardService";

export const getDashboardData = createAsyncThunk(
  "dashboard/getDashboardData",
  async (period, thunkAPI) => {
    const data = await fetchDashboardData(period);
    return data;
  }
);

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    loading: false,
    error: null,
    data: null,
    period: "monthly", // <-- set default here
  },
  reducers: {
    setPeriod(state, action) {
      state.period = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDashboardData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDashboardData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getDashboardData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { setPeriod } = dashboardSlice.actions;
export default dashboardSlice.reducer;